var offset_value = 5,
    more_posts_offset = 0,
    load_more_button = $('#showMorePosts'),
    loaded_more_times = 1,
    offset_top = 0;

$(document).ready(function () {
    if ($("[data-endposts]").length > 0) {
        load_more_button.addClass("hide");
    }
});

$(window).scroll(function(){
  offset_top = $(this).scrollTop();
});

load_more_button.click(function() {

    var category = (load_more_button.data("category")) ? load_more_button.data("category") : "",
        postyear = (load_more_button.data("postyear")) ? load_more_button.data("postyear") : "",
        theData = {
            'action' : 'load_more',
            'offset' : offset_value,
        };

    if (category) {
        theData['categoryName'] = category;
    }

    if (postyear) {
        theData['y'] = postyear;
    }

    $.ajax({
        url: ajaxurl,
		dataType: "HTML",
        data: theData,
        success: function (data) {

            $('#morePosts').append(data);

            // mark off where the first element that just got loaded in is so we have a point we can scroll the user to
            $("#morePosts").children().eq(more_posts_offset).attr("id", "1" + loaded_more_times);

            // scroll the user down to the posts that were just added
            var new_offset_top = $("#1" + loaded_more_times).offset().top - 200;
            var wo = $(window).scrollTop();
            // console.log(new_offset_top);
            //$("body, html").animate({ scrollTop: "+=" + new_offset_top - $(window).scrollTop() }, "slow");
            $("html,body").animate({scrollTop: "+=" + (new_offset_top - wo)}, "slow");

            $('.matchHeight').matchHeight();
            offset_value += 3;
            more_posts_offset += 3;

            if ($("[data-endposts]").length > 0) {
                load_more_button.addClass("hide");
            }

            loaded_more_times++;
        }
    });
    return false;
});
